module.exports = __webpack_public_path__ + "static/media/MacleanW.395345a8.jpeg";